export default ({ app }) => {
    // console.log(app.nuxt.defaultTransition);
    // app.nuxt.defaultTransition.beforeEnter = () => {
    // };
};
